import type { ApolloError } from '@apollo/client';
import { noop } from 'lodash-es';
import { createContext } from 'react';

export type GlobalGraphQLErrorHandler = {
  onGraphQlError: (errors: ApolloError['graphQLErrors']) => void;
  onNetworkError: (error: ApolloError['networkError']) => void;
};

export const GraphQLErrorHandlerContext = createContext<GlobalGraphQLErrorHandler>({
  onGraphQlError: noop,
  onNetworkError: noop,
});
